import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { PackageInfo } from '../../types'
import styles from '../../styles/PackageInfoCard.module.css'
import { findCodeAndEmoji } from '../../data/supportLanguage'
import { getLanguageName } from '../../utils/languageListFunction'

export default function PackageOtherLangInfo({
  packageInfo,
}: {
  packageInfo: PackageInfo
}) {
  const name = packageInfo.name
  const description = packageInfo.description
  const otherNameLangCode = []
  for (const key in name) {
    if (key !== 'en') {
      otherNameLangCode.push(key)
    }
  }
  if (otherNameLangCode.length === 0) return <></>
  return (
    <div className={styles.wrapper}>
      <p className={styles.head}>
        <FormattedMessage
          id={'PackageInfo.title.additional'}
          defaultMessage={'Pack information (Additional)'}
        />
      </p>
      <div>
        {otherNameLangCode.map((langCode) => {
          const langInfo = findCodeAndEmoji(langCode)
          if (langInfo) {
            return (
              <div key={langCode} className={styles.otherLangContent}>
                <div className={styles.row}>
                  <span>{langInfo.emoji}</span>
                  <span className={styles.langName}>
                    {langInfo.name === 'Others'
                      ? getLanguageName(langCode)
                      : langInfo.name}
                  </span>
                </div>
                <div className={styles.row}>
                  <div className={styles.packName}>
                    <FormattedMessage
                      id={'ReviewedPkgList.table.pkgName'}
                      defaultMessage={'Pack name'}
                    />
                  </div>
                  <span>{name[langCode]}</span>
                </div>
                <div className={styles.row}>
                  <div className={styles.packName}>
                    <FormattedMessage
                      id={'PackageInfo.package.description.pack'}
                      defaultMessage={'Pack Description'}
                    />
                  </div>
                  <span>{description[langCode]}</span>
                </div>
              </div>
            )
          }
          return <></>
        })}
      </div>
    </div>
  )
}
